var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            size: "lg",
            title: "Confirm your password",
            "modal-class": "vue-need-bootstrap",
            lazy: "",
            centered: "",
            "hide-footer": "",
          },
          model: {
            value: _setup.showPasswordPrompt,
            callback: function ($$v) {
              _setup.showPasswordPrompt = $$v
            },
            expression: "showPasswordPrompt",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _setup.passwordPromptMode === "show",
                  expression: "passwordPromptMode === 'show'",
                },
              ],
            },
            [_vm._v("Please, confirm your current password to proceed:")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _setup.passwordPromptMode === "generate",
                  expression: "passwordPromptMode === 'generate'",
                },
              ],
            },
            [
              _c("b", [
                _vm._v(
                  "WARNING: Generating a new API Key will invalidate your current one!"
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(_setup.ValidationObserver, {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ handleSubmit, valid }) {
                  return [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return handleSubmit(_setup.handlePasswordSubmit)
                          },
                        },
                      },
                      [
                        _c(_setup.ValidationProvider, {
                          attrs: { rules: "required|min:8", name: "Password" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ valid, errors }) {
                                  return [
                                    _c(
                                      "b-form-group",
                                      {
                                        staticClass: "my-3",
                                        attrs: {
                                          id: "password-input",
                                          "label-cols": "3",
                                          "content-cols": "9",
                                          label: "Password",
                                          "label-for": "password-input",
                                          "invalid-feedback": _setup.invalidPassword
                                            ? "Wrong password"
                                            : errors[0],
                                          state: _setup.invalidPassword
                                            ? false
                                            : errors[0]
                                            ? false
                                            : valid
                                            ? true
                                            : null,
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "password",
                                            state: _setup.invalidPassword
                                              ? false
                                              : errors[0]
                                              ? false
                                              : valid
                                              ? true
                                              : null,
                                            disabled: _setup.loadingApiKey,
                                          },
                                          model: {
                                            value: _setup.password,
                                            callback: function ($$v) {
                                              _setup.password = $$v
                                            },
                                            expression: "password",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _setup.fatalError,
                                expression: "fatalError",
                              },
                            ],
                            staticClass: "error-message w-100 pb-3 text-center",
                          },
                          [_vm._v("Error retrieving API Key")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "modal-footer row pb-0" },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  type: "reset",
                                  disabled: _setup.loadingApiKey,
                                },
                                on: {
                                  click: function ($event) {
                                    _setup.showPasswordPrompt = false
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        Cancel\n                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              _setup.LoaderBtn,
                              {
                                attrs: {
                                  variant: "primary",
                                  type: "submit",
                                  "loading-text": "Loading",
                                  loading: _setup.loadingApiKey,
                                  disabled: !valid || _setup.loadingApiKey,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _setup.passwordPromptMode === "show"
                                        ? "Show"
                                        : "Generate"
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "api-key-input",
            label: "API Key",
            "label-for": "api-key-input",
          },
        },
        [
          _c(
            "b-input-group",
            [
              _c("b-form-input", {
                staticStyle: { cursor: "auto" },
                attrs: {
                  id: "api-key-input",
                  type: _setup.inputType,
                  required: "",
                  readonly: "",
                },
                model: {
                  value: _setup.apiKey,
                  callback: function ($$v) {
                    _setup.apiKey = $$v
                  },
                  expression: "apiKey",
                },
              }),
              _vm._v(" "),
              _c(
                "b-input-group-append",
                [
                  _c(
                    "b-btn",
                    {
                      attrs: {
                        variant: "primary",
                        disabled: !_setup.canShowApiKey,
                      },
                      on: {
                        click: function ($event) {
                          return _setup.showApiKey()
                        },
                      },
                    },
                    [_vm._v("Show")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.allowRegenerate && _setup.user
            ? _c("b-form-text", { staticClass: "text-right link" }, [
                _c(
                  "a",
                  {
                    class: { disabled: _setup.loadingApiKey },
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function ($event) {
                        !_setup.user.ImpersonatedFromAdminUser
                          ? _setup.promptPassword("generate")
                          : _setup.generateApiKey()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                Generate new API Key\n            "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }